import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function BioDataForm() {
  const [open, setOpen] = React.useState(false);

  const Navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
    Navigate("/admin-page/student");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    oname: "",
    dob: "",
    mobile: "",
    state: "",
    localgovt: "",
    address: "",
    fathersfname: "",
    mothersfname: "",
    guardiansmobile: "",
  });

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check for empty fields
    const isEmptyField = Object.values(formData).some((value) => value === "");

    if (isEmptyField) {
      alert("Please fill out all fields");
    } else {
      // Submit the form (you can implement your submission logic here)

      console.log("data");

      //  console.log("Form submitted:", );
      setFormData({
        fname: "",
        lname: "",
        oname: "",
        dob: "",
        mobile: "",
        state: "",
        localgovt: "",
        address: "",
        fathersfname: "",
        mothersfname: "",
        guardiansmobile: "",
      });
    }
  };
  return (
    <div className="h-fit">
      <form onSubmit={handleSubmit}>
        <TextField
          label="First Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.fname}
          onChange={handleInputChange("fname")}
        />
        <TextField
          label="Last Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.lname}
          onChange={handleInputChange("lname")}
        />
        <TextField
          label="Other Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.oname}
          onChange={handleInputChange("oname")}
        />
        <TextField
          label="Date of birth"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.dob}
          onChange={handleInputChange("dob")}
        />
        <TextField
          label="Mobile Number"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.mobile}
          onChange={handleInputChange("mobile")}
        />
        <TextField
          label="State of Origin"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.state}
          onChange={handleInputChange("state")}
        />
        <TextField
          label="Local Govt"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.localgovt}
          onChange={handleInputChange("localgovt")}
        />
        <TextField
          label="Home Address"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.address}
          onChange={handleInputChange("address")}
        />
        <TextField
          label="Father's Full Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.fathersfname}
          onChange={handleInputChange("fathersfname")}
        />
        <TextField
          label="Mother's Full Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.mothersfname}
          onChange={handleInputChange("mothersfname")}
        />
        <TextField
          label="Guardian's Mobile Number"
          type="email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.guardiansmobile}
          onChange={handleInputChange("guardiansmobile")}
        />
        <Button type="submit" variant="contained" color="primary">
          Add
        </Button>
      </form>
    </div>
  );
}

export default BioDataForm;
